export const isLifetimeFounder = (userProfile) => {
  return (
    userProfile?.founder === true ||
    userProfile?.isFounder === true ||
    userProfile?.founderAccount === true ||
    typeof userProfile?.founderNumber === "number" ||
    userProfile?.subscriptionStatus === "free_lifetime" ||
    userProfile?.plan === "founder"
  );
};

export const hasPremiumAccess = (userProfile) => {
  const isAdmin =
    userProfile?.admin === true ||
    userProfile?.isAdmin === true;

  const isPaid =
    userProfile?.premiumAccess === true ||
    userProfile?.subscriptionStatus === "active" ||
    userProfile?.subscriptionStatus === "trialing";

  return isAdmin || isLifetimeFounder(userProfile) || isPaid;
};
